const MOCK_SESSION_KEY = "uw_mock_mode";

export const isOfflineMode = (): boolean => {
  // Runtime toggle takes precedence over the build-time env var
  const session = sessionStorage.getItem(MOCK_SESSION_KEY);
  if (session !== null) return session === "true";
  return import.meta.env.VITE_OFFLINE_MODE === "true";
};

export const setMockMode = (enabled: boolean): void => {
  sessionStorage.setItem(MOCK_SESSION_KEY, String(enabled));
};

export const isMockModeOverridden = (): boolean =>
  sessionStorage.getItem(MOCK_SESSION_KEY) !== null;
